import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AddEmployeeDto } from '../../../../models/employee/add-employee-dto';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { EmployeeDatabase } from './employeeDatabase';

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, StoreDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class EmployeeDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    _jobTitleId = -1;

    filteredData: AddEmployeeDto[] = [];
    renderedData: AddEmployeeDto[] = [];
    dataLength = 0;

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    filterByJobTitle(_jobTitleId) {
        this._jobTitleId = _jobTitleId;
        this._filterChange.next(this.filter);
    }

    constructor(
        private _employeeDatabase: EmployeeDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort,
        private _jobTitleSelected
    ) {
        super();
        this._jobTitleId = _jobTitleSelected;

        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<AddEmployeeDto[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._employeeDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._employeeDatabase.data.slice().filter((item: AddEmployeeDto) => {
                const searchStr = (item.LastName).toLowerCase();
                return (searchStr.indexOf(this.filter.toLowerCase()) !== -1 &&
                    (this._jobTitleId === -1 || item.JobTitles.find(job => job.JobTitleId === this._jobTitleId)));
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._employeeDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: AddEmployeeDto[]): AddEmployeeDto[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'LastName':
                    [propertyA, propertyB] = [a.LastName, b.LastName];
                    break;
                // case '':
                //     [propertyA, propertyB] = [a.description, b.description];
                //     break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/employeeDataSource.ts